<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Change Electronic Consent Setting</h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="step == 'get-consent'" class="text-center">
                        <h2 class="bold">Hey, {{userName}},</h2>
                        <p>the new condo act requires residents to consent to receive documents electronically.</p>
                        <button class="btn btn-primary submit m-b-sm m-t-sm" type="button" (click)="step = 'agreement'">
                            Consent to receive documents electronically
                        </button>
                        <br>
                        <button class="btn btn-outline-primary submit m-b-lg" type="button" (click)="step = 'confirm-decline'">
                            Do not consent
                        </button>
                    </div>
                    <div *ngIf="step == 'confirm-decline'" class="text-center">
                        <h2 class="bold">Wait, are you sure?!</h2>
                        <p>You will not be able to receive notifications from your building, in regards to: </p>
                        <button class="btn btn-primary submit m-b-md"
                                type="button"
                                [disabled]="disabledSubmit"
                                (click)="step = 'get-consent'">
                            No, Go Back!
                        </button>
                        <br>
                        <button class="btn btn-outline-primary submit m-b-lg"
                                type="button"
                                [disabled]="disabledSubmit"
                                (click)="removeResidentConsent()">
                            Yes, I am Sure
                        </button>
                    </div>
                    <div *ngIf="step == 'agreement'" class="text-center">
                        <h2 class="bold">Please note the corporation will use email to deliver notices to you</h2>
                        <p>I agree that I am sufficiently surved, as described in section 54 of the Condominium Act,
                           1998, if the corporation uses the method of delivering documents identified in this agreement.
                        </p>
                        <button class="btn btn-primary submit m-b-lg m-t-sm" type="button" (click)="changeSignatureType('choose-signature')">
                            I agree
                        </button>
                    </div>
                    <div *ngIf="step == 'choose-signature'" class="text-center">
                        <h2 class="bold">
                            Choose Electronic Signature, or
                            <span class="clickable-text" (click)="changeSignatureType('draw-signature')">draw your own</span>
                        </h2>

                        <ul class="signature-fonts-list">
                            <li *ngFor="let font of fontList; let i = index">
                                <div class="item-font"
                                     [ngStyle]="{'font-family': font + ',' + 'cursive'}"
                                     [ngClass]="{'mtv-primary-border': chosenFont == font}"
                                     (click)="onChosenFont(font, 'FontElement_' + i);">
                                    <span [id]="'FontElement_' + i">{{userName}}</span>
                                </div>
                            </li>
                        </ul>

                        <button class="btn btn-primary submit m-b-lg" type="button" (click)="chooseFont()">
                            Continue
                        </button>
                    </div>
                    <div *ngIf="step == 'draw-signature'" class="text-center">
                        <h2 class="bold">
                            <span class="clickable-text" (click)="step = 'choose-signature'">Choose</span>
                            an electronic signature or draw your own
                        </h2>

                        <div class="signature-wrapper">
                            <signature-pad [options]="signaturePadOptions"
                                           (onBeginEvent)="drawStart()"
                                           id="signatureCanvas">
                            </signature-pad>
                        </div>

                        <button class="btn btn-primary submit m-b-sm" type="button" (click)="drawComplete()">
                            Continue
                        </button>
                        <br>
                        <button type="button" class="btn btn-outline-primary submit m-b-lg" (click)="drawClear()">
                            Clear
                        </button>
                    </div>
                    <div *ngIf="step == 'signature-confirmation'" class="text-center">
                        <h2 class="bold">
                            I agree that signature I have selected above will be the electronic representation of my signature and
                            for all purposes when I use them in any Max Condo Club Signing Session, including legally
                            binding documents and contracts; just the same as traditional pen-and-paper signature.
                        </h2>
                        <button class="btn btn-primary submit m-b-lg m-t-sm"
                                type="button"
                                [disabled]="disabledSubmit"
                                (click)="createResidentConsent()">
                            I agree
                        </button>
                    </div>
                    <div *ngIf="step == 'show-filled-form'" class="text-center">
                        <pdf-viewer [src]="pathToPDF"
                                    [page]="pdfPage"
                                    [zoom]="zoom"
                                    [fit-to-page]="true"
                                    [original-size]="false"
                                    (after-load-complete)="onPdfLoaded($event)"
                                    [show-all]="false"
                                    [render-text]="true"
                                    style="display: block; margin: 0 -30px;">
                        </pdf-viewer>
                        <div class="pdf-tools-row">
                            <i *ngIf="currentPdfMaxPage > 1"
                               (click)="previousPage()"
                               class="fa fa-chevron-left mtv-primary-color">
                            </i>
                            <i class="fa fa-minus mtv-primary-color" (click)="zoomOut()"></i>
                            <i class="fa fa-plus mtv-primary-color" (click)="zoomIn()"></i>
                            <i *ngIf="currentPdfMaxPage > 1"
                               (click)="nextPage()"
                               class="fa fa-chevron-right mtv-primary-color">
                            </i>
                        </div>

                        <button class="btn btn-primary submit m-t-md m-b-lg"
                                type="button"
                                (click)="step = 'finished';hideModal();">
                            Complete your Signing Session
                        </button>
                    </div>
                    <div *ngIf="step == 'finished'" class="text-center">
                        <h2 class="bold">Thank you! Now you are all set.</h2>
                        <button class="btn btn-primary submit m-b-lg" type="button" (click)="hideModal()">
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <spinner [spinnerShow]="spinnerShow"></spinner>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/profile/change-waiver-settings-modal/change-waiver-settings-modal.component.html